import {
  createContext,
  useContext,
} from 'react'
import type { DashboardBootstrapState } from './useDashboardBootstrap'

export const DashboardBootstrapContext = createContext<DashboardBootstrapState | null>(null)

export function useDashboardBootstrapContext() {
  const context = useContext(DashboardBootstrapContext)

  if (!context) {
    throw new Error(
      'useDashboardBootstrapContext must be used inside DashboardBootstrapProvider.',
    )
  }

  return context
}
